import { render, staticRenderFns } from "./SalonMessages.vue?vue&type=template&id=9cc46450&scoped=true"
import script from "./SalonMessages.vue?vue&type=script&lang=js"
export * from "./SalonMessages.vue?vue&type=script&lang=js"
import style0 from "./SalonMessages.vue?vue&type=style&index=0&id=9cc46450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc46450",
  null
  
)

export default component.exports